import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="relative bg-cream py-[40px] md:py-[64px] px-6 overflow-hidden" data-id="element-179">
      {/* Giant watermark shield */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none opacity-[0.03]" data-id="element-180">
        <ShieldCheck className="w-[300px] h-[300px] text-sage" data-id="element-181" />
      </div>

      <div className="relative z-10 max-w-[860px] mx-auto" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-surface/80 backdrop-blur-sm border border-border rounded-[16px] p-8 md:p-12 flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-12 shadow-sm" data-id="element-183">
          <div className="flex-shrink-0" data-id="element-184">
            <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-sm border border-border-light" data-id="element-185">
              <ShieldCheck className="w-12 h-12 text-sage" data-id="element-186" />
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-187">
            <h2 className="font-serif font-[900] text-[36px] md:text-[40px] leading-[1.15] text-text-primary mb-6" data-id="element-188">
              Garantía Total de 7 Días
              <br className="hidden md:block" data-id="element-189" /> — Sin Preguntas
            </h2>

            <p className="font-lora text-[18px] leading-[1.8] text-text-secondary" data-id="element-190">
              Si por cualquier razón sientes que este libro no te aportó el
              valor que prometió, escríbeme dentro de los próximos 7 días y te
              devuelvo cada centavo. Sin formularios. Sin explicaciones. Sin
              trámites. El riesgo es completamente mío. Tu único riesgo real es
              seguir sin el mapa.
            </p>
          </div>
        </motion.div>
      </div>

      {/* Section Separator */}
      <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-b from-transparent to-[#FAF7F0]" data-id="element-191"></div>
    </section>;
}